import React, { useState } from 'react';
import {
	Box,
	Container,
	Grid,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Headers from '../components/reusableComponents/Headers';
import Carousel from '../components/reusableComponents/Carousel';
import Footer from '../components/reusableComponents/Footer';
import BlogsSection from './BlogsSection';
import CarouselInterHoliday from '../components/reusableComponents/CarouselInterHoliday';
import SearchEngineForex from '../form/SearchEngineForex';
const data = [
	{
		fontawsClass: 'fa fa-building-o',
		title: 'Our Offices',
		desc: 'Located across the country, ready to assist in planning & booking your perfect vacation.',
		footer: 'Locate Us',
	},
	{
		fontawsClass: 'fa fa-phone',
		title: 'Call us',
		desc: "Request a quote, or just chat about your next vacation. We're always happy to help!",
		footer: '(+91) 8877773388',
	},
	{
		fontawsClass: 'fa fa-envelope',
		title: 'Write to us',
		desc: 'Be it an enquiry, feedback or a simple suggestion, write to us.',
		footer: 'info@musafirbazar.com',
	},
	{
		fontawsClass: 'fa fa-share-alt',
		title: 'Connect with us',
		desc: 'Check out reviews, podcasts, blogs and more...',
		footer: '',
	},
];
const tours = [
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/w4bPBhtX3SHBy8IFoVkzP_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'Accommodation',
		desc: 'Comfortable & convenient hotels cherry picked by our hotel management team',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/yHA3fK6OsEC0YtsoZ4FTd_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'All meals',
		desc: "Eat to your heart's content Breakfast. Lunch. Dinner.",
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/rrm8NL4AYhsvTS7wQHt6r_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'On-tour transport',
		desc: 'Our itineraries include all rail, sea and road transport as part of the itinerary so you can enjoy tension free',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/DGfXqw_ELotA0nLoZzlGl_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'Tour managers',
		desc: 'We have an exclusive team of 350 tour managers specialising in India and World tours',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/smwH_pmuojWhdntRsVv6n_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'Best value itinerary',
		desc: 'Our dedicated product & destination research team spends hours curating the best value for money itineraries',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/bZxPCnAKkkHClpkv_d5FR_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'To and fro airfare',
		desc: 'MusafirBazar tours are inclusive of airfare from many hubs within India unless you pick the joining-leaving option',
	},
];
const LandingPage = () => {
	const [value, setValue] = useState('one');
	const handleChange = (val) => {
		setValue(val);
	};
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<>
			<Headers />
			<div
				style={{
					background:
						'linear-gradient(253.92deg, rgb(213 193 45) 0%, rgb(50 176 148) 40.97%, rgb(54 145 85) 100%)',
					height: 450,
					marginTop: matches ? 25 : '',
				}}>
				<Container style={{ paddingTop: 20 }}>
					<Grid container>
						<Grid item xs={12} lg={6}>
							<Box>
								<h1 style={{ fontFamily: 'Dancing Script', color: 'white' }}>
									This Women's Day,
								</h1>
								<h1 style={{ fontFamily: 'Dancing Script', color: 'white' }}>
									41 Women's Special tours for friends
								</h1>
							</Box>
						</Grid>
						<Grid item xs={12} lg={6}>
							<img
								src='https://www.veenaworld.com/assets/images/home-new/womens-day/group-of-people-desktop.svg'
								style={{ width: '100%' }}
							/>
						</Grid>
					</Grid>
					{/* <Box
						style={{ display: 'flex', justifyContent: 'space-between' }}></Box> */}
				</Container>
				<Container
					style={{
						background: 'white',
						padding: '36px',
						borderRadius: 5,
					}}>
					<SearchEngineForex />
					<h6 style={{ textAlign: 'center', marginTop: 20 }}>
						Let your hair down. Set your spirit free. It’s time to have a blast.
					</h6>
					<CarouselInterHoliday />
				</Container>
			</div>
			{/* <Container style={{ marginTop: 200 }}>
				<h3 style={{ textAlign: 'center' }}>
					What’s on your 2023 travel bucketlist?
				</h3>
				<Grid container spacing={4} style={{ marginTop: 40, marginBottom: 40 }}>
					{[0, 1, 2, 3, 4, 5].map(() => {
						return (
							<Grid
								item
								xs={12}
								lg={2}
								style={{
									width: 'calc(16.6666666667% - 20px)',
									// margin: '0 10px',
									// borderRadius: '10px',
									position: 'relative',
									minHeight: '330px',
									color: '#fff',
									textAlign: 'center',
									cursor: 'pointer',
									background:
										'linear-gradient(180deg,rgba(0,0,0,0) 0%,#000000 100%)',
								}}>
								<img
									src='https://img.veenaworld.com/group-tours/india/jammu-and-kashmir/jklh/lhdl-ip-thb-jklh-2152022.jpg'
									style={{ width: '100%', height: '100%', borderRadius: '5px' }}
								/>
							</Grid>
						);
					})}
				</Grid>
			</Container> */}
			<Container style={{ marginTop: matches ? 565 : 250, marginBottom: 40 }}>
				<h4 style={{ textAlign: 'center', marginBottom: 20 }}>
					All inclusive tours, Chalo Bag Bharo Nikal Pado!
				</h4>
				<Grid container spacing={4}>
					{tours.map((r) => {
						return (
							<Grid item xs={12} lg={4}>
								<Box style={{ textAlign: 'center' }}>
									<img src={r.image} />
									<h3 style={{ color: '#29499a' }}>{r.title}</h3>
									<span style={{ fontSize: 14 }}>{r.desc}</span>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			<Carousel />

			{/* <Container style={{ marginTop: 100, marginBottom: 20 }}>
				<h3 style={{ textAlign: 'center' }}>
					Travel tips, hacks, tricks and a whole lot more...
				</h3>
				<Grid container spacing={4} style={{ marginTop: 20 }}>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
				</Grid>
			</Container> */}
			<Container>
				<h3 style={{ textAlign: 'center' }}>Hit the road!</h3>
				<Grid container style={{ marginTop: 20 }} spacing={2}>
					<Grid item xs={12} lg={4}></Grid>
					<Grid item xs={12} lg={5}>
						<Box style={{ justifyContent: 'space-evenly', display: 'flex' }}>
							<Box
								onClick={() => handleChange('one')}
								style={{
									border: '1px solid grey',
									padding: 10,
									background: value === 'one' ? '#294992' : '',
									borderRadius: 5,
									cursor: 'pointer',
								}}>
								<span
									style={{
										color: value === 'one' ? 'white' : 'black',
										fontSize: matches ? 12 : '',
									}}>
									Explore Mightly Himalayas
								</span>
							</Box>
							<Box
								onClick={() => handleChange('two')}
								style={{
									border: '1px solid grey',
									padding: 10,
									borderRadius: 5,
									background: value === 'two' ? '#294992' : '',
									cursor: 'pointer',
								}}>
								<span
									style={{
										color: value === 'two' ? 'white' : 'black',
										fontSize: matches ? 12 : '',
									}}>
									Get Ready For Expedition
								</span>
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12} lg={3}></Grid>
				</Grid>
				<Grid container spacing={4} style={{ marginTop: 20, marginBottom: 20 }}>
					{Array.from(Array(3)).map(() => {
						return (
							<Grid item xs={12} lg={4}>
								<Box
									style={{
										boxShadow: '0 0 10px #00000012',
										border: '1px solid #D8D8D8',
										padding: 20,
										borderRadius: 5,
									}}>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<img
											src='https://img.veenaworld.com/group-tours/india/leh-ladakh/lhmn/lhmn-thb.jpg'
											style={{ height: '100px', borderRadius: 12 }}
										/>
										<Box style={{}}>
											<h5>Leh Ladakh Manali</h5>
											<span>11 Days 8 Cities</span>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											// justifyContent: 'space-between',
										}}>
										<Box style={{ marginTop: 10 }}>
											{/* <h5>Leh Ladakh Manali</h5> */}
											<span style={{ fontSize: 12, color: 'grey' }}>
												Travel | 11 Days | 1 Country | 8 Cities
											</span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}>
												2 Departure Cities | 2 Departure Dates
											</span>
										</Box>
									</Box>

									<Grid container spacing={4} style={{ marginTop: 20 }}>
										<Grid item xs={12} lg={6}>
											<Box
												style={{
													background: '#DFE4F0',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
												}}>
												<span>₹ Quick Quote</span>
											</Box>
											<Box
												style={{
													// background: '#DFE4F0',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
													marginTop: 10,
													border: '1px solid green',
												}}>
												<span style={{ fontSize: 12 }}>
													Lowest Price 15 Jun 2023
												</span>
											</Box>
										</Grid>
										<Grid item xs={6} style={{ textAlign: 'end' }}>
											<span style={{ color: 'green', fontSize: 12 }}>
												SUPER DEAL PRICE
											</span>
											<h2>{value === 'two' ? '₹8500' : '₹9876'}</h2>
											<p style={{ fontSize: 12 }}>per person on twin sharing</p>
										</Grid>
									</Grid>
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<Box
												style={{
													background: 'yellow',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
												}}>
												<span>View Details</span>
											</Box>
										</Grid>
										<Grid item xs={6}>
											<Box
												style={{
													border: '1px solid lightgrey',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
												}}>
												<span>Enquiry Now</span>
											</Box>
										</Grid>
									</Grid>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			<Box
				style={{
					background: `url(${'https://img.veenaworld.com/vw-assets/images/homepage/World-map.svg'}) #16283A no-repeat center`,
					// height: 500,
				}}>
				<Container style={{ paddingTop: 30, paddingBottom: 30 }}>
					<span
						style={{
							color: 'white',
						}}>
						We're curating experiences that
					</span>
					<h1 style={{ color: 'yellow', fontWeight: 'bold' }}>
						win heart and celebrate Life
					</h1>
					<Grid container style={{ marginTop: 80 }}>
						<Grid item xs={12} lg={6}>
							<Box
								style={{
									alignItems: 'center',
									justifyContent: 'space-between',
									display: matches ? '' : 'flex',
								}}>
								<Box>
									<i
										class='fas fa-smile'
										style={{ color: 'white', fontSize: 30 }}></i>
									<h1 style={{ color: 'white' }}>6,10,291</h1>
									<span style={{ color: 'white' }}>Happy guests</span>
								</Box>
								<Box style={{ marginTop: 20 }}>
									<i
										class='fas fa-smile'
										style={{ color: 'white', fontSize: 30 }}></i>
									<h1 style={{ color: 'white' }}>43,984</h1>
									<span style={{ color: 'white' }}>Tours completed</span>
								</Box>
								<Box style={{ marginTop: 20 }}>
									<i
										class='fas fa-smile'
										style={{ color: 'white', fontSize: 30 }}></i>
									<h1 style={{ color: 'white' }}>2500+</h1>
									<span style={{ color: 'white' }}>Tour destinations</span>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12} lg={6}></Grid>
					</Grid>
				</Container>
			</Box>
			<Container style={{ marginTop: 40, marginBottom: 40 }}>
				<Grid container spacing={4}>
					<Grid item xs={12} lg={6}>
						<img
							src='https://img.veenaworld.com/og-images/india-og-1.jpg'
							style={{ width: '100%', height: '100%', borderRadius: 5 }}
						/>
					</Grid>
					<Grid item xs={12} lg={6}>
						<img
							src='https://img.veenaworld.com/og-images/india-og-1.jpg'
							style={{ width: '100%', height: '100%', borderRadius: 5 }}
						/>
					</Grid>
				</Grid>
			</Container>
			<Container style={{ marginTop: 20, marginBottom: 20 }}>
				<Grid container spacing={4}>
					{data.map((r, index) => {
						return (
							<Grid item xs={12} lg={3}>
								<Box>
									<i class={r.fontawsClass} aria-hidden='true'></i>
									<span style={{ marginLeft: 10, fontSize: 20 }}>
										{r.title}
									</span>
									<br />
									<p style={{ fontSize: 12 }}>{r.desc}</p>
									{index === 3 ? (
										<>
											<i
												class='fa fa-facebook-square'
												aria-hidden='true'
												style={{ fontSize: 30 }}></i>
											<i
												class='fa fa-youtube-play'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-linkedin'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-instagram'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-twitter'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
										</>
									) : (
										<span style={{ color: 'darblue', fontWeight: 'bold' }}>
											{r.footer}
										</span>
									)}
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			<Footer />
		</>
	);
};

export default LandingPage;
